/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { Text } from '@/shared/ui';

/**
 * The label above a group inside the calendar settings.
 *
 * Deliberately not a monospaced all-caps eyebrow: that treatment reads as a
 * system tag rather than as a heading someone wrote, and these labels say
 * something the user needs to read. Interface family, small scale, sentence
 * case.
 *
 * @param props - The label text.
 * @returns The rendered label.
 */
export const GroupLabel: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Text
    component="span"
    className="block text-[length:var(--text-small)] font-[weight:var(--font-semibold)] text-[var(--text-secondary)]"
  >
    {children}
  </Text>
);
